const configlive = {
    mode: "live",
    web_url: "https://markii.gdq.se",
    front_url: "https://markii.gdq.se",
    admin_url: "https://admin.gdq.se",
    base_url: "https://api.gdq.se",
    report_url: "https://reports.gdq.se",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
const configtest = {
    mode: "test",
    web_url: "http://localhost:8080",
    front_url: "http://localhost:8080",
    admin_url: "http://localhost:8081",
    base_url: "http://brain/gdq_api",
    report_url: "http://brain/gdq_reports",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
const configstage = {
    mode: "stage",
    web_url: "https://markii.test.gdq.se",
    front_url: "https://markii.test.gdq.se",
    admin_url: "https://admin.test.gdq.se",
    base_url: "https://api.test.gdq.se",
    report_url: "https://reports.test.gdq.se",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
let config = configlive;
const location = window.location.host;

if (location.indexOf(".test.gdq.se") > 0) {
    config = configstage;
}
if (location.indexOf("gdq.se") < 0) {
    config = configtest;
}
export { config };
